/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AerialImagesListCenter
 */
export interface AerialImagesListCenter {
    /**
     * 
     * @type {AerialImagesListCenterTypeEnum}
     * @memberof AerialImagesListCenter
     */
    type?: AerialImagesListCenterTypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof AerialImagesListCenter
     */
    coordinates?: Array<number>;
}


/**
 * @export
 */
export const AerialImagesListCenterTypeEnum = {
    Point: 'Point'
} as const;
export type AerialImagesListCenterTypeEnum = typeof AerialImagesListCenterTypeEnum[keyof typeof AerialImagesListCenterTypeEnum];


/**
 * Check if a given object implements the AerialImagesListCenter interface.
 */
export function instanceOfAerialImagesListCenter(value: object): value is AerialImagesListCenter {
    return true;
}

export function AerialImagesListCenterFromJSON(json: any): AerialImagesListCenter {
    return AerialImagesListCenterFromJSONTyped(json, false);
}

export function AerialImagesListCenterFromJSONTyped(json: any, ignoreDiscriminator: boolean): AerialImagesListCenter {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'coordinates': json['coordinates'] == null ? undefined : json['coordinates'],
    };
}

export function AerialImagesListCenterToJSON(json: any): AerialImagesListCenter {
    return AerialImagesListCenterToJSONTyped(json, false);
}

export function AerialImagesListCenterToJSONTyped(value?: AerialImagesListCenter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'coordinates': value['coordinates'],
    };
}

